import { Injectable } from '@angular/core';
import { RoutingUtilService as CommonRoutingUtilService, PathWithParams as CommonPathWithParams } from 'gung-common';

@Injectable({
  providedIn: 'root'
})
export class RoutingUtilService extends CommonRoutingUtilService { }

export interface PathWithParams extends CommonPathWithParams { }
